import { render, staticRenderFns } from "./afasTitleSelect.vue?vue&type=template&id=586d665d&"
import script from "./afasTitleSelect.vue?vue&type=script&lang=js&"
export * from "./afasTitleSelect.vue?vue&type=script&lang=js&"
import style0 from "./afasTitleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports